import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const routes = [
  {
    path: "/index",
    component: () => import("@/views/index"),
    meta: {
      title: "index",
      keepAlive: true,
    },
  },
  {
    path: "/order-flow",
    component: () => import("@/views/order-flow"),
    meta: {
      title: "order-flow",
      keepAlive: true,
    },
  },
  {
    path: "/sales-questions",
    component: () => import("@/views/sales-questions"),
    meta: {
      title: "sales-questions",
      keepAlive: true,
    },
  },
  {
    path: "/product-support",
    component: () => import("@/views/product-support"),
    meta: {
      title: "product-support",
      keepAlive: true,
    },
  },
  {
    path: "/",
    redirect: "/index",
    meta: {
      title: "index",
    },
  },
];
const router = new Router({
  scrollBehavior: () => ({ y: 0 }),
  mode: "history",
  base: "/",
  routes,
});

export default router;
